import { Star } from "./Icons";

const WORDS = ["Microblading", "Ricostruzione unghie", "Nail art", "Sopracciglia pelo a pelo", "Gel & Acrygel", "Frascati"];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-8 font-display text-4xl italic md:px-12 md:text-6xl ${i % 2 ? "text-stroke" : "text-[var(--ink)]"}`}>{w}</span>
        <Star className="h-5 w-5 text-[var(--gold)]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[var(--gold)]/25 bg-[var(--blush)]/50 py-8 md:py-10">
    <div className="animate-marquee flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
